import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose, withProps } from 'recompose';
import { CurrencySelect, ICurrencySelectProps } from './CurrencySelect';
import * as _ from 'lodash';

const GetCurrencyListQuery = gql`
  query {
    currencies {
      id
      value
    }
  }
`;

export default compose<{}, ICurrencySelectProps>(
  graphql<ICurrencySelectProps, any>(GetCurrencyListQuery, {
    name: 'currencies',
  }),
  withProps(({ currencies }: any) => {
    return {
      currencies: currencies.currencies,
    };
  }),
)(CurrencySelect);



// WEBPACK FOOTER //
// ./src/components/Others/CurrencySelect/index.ts